import isString from 'lodash/isString';
import time from 'yoda-core-components/lib/moment/Time';
import orderBy from 'lodash/orderBy';
import forEach from 'lodash/forEach';

/**
 * Return filters with previous two years along with config filters
 * @param noOfPreviousYears
 * @param NewOrdersFilterOptions
 * @return Array of Object
 */
export const getFilterDropdown = (noOfPreviousYears, NewOrdersFilterOptions) => {
    const date = new Date();
    const currentYear = date.getFullYear();
    const ordersFilter = [...NewOrdersFilterOptions];
    const prevYears = [];
    const isObject = NewOrdersFilterOptions.some((value) => {
        return typeof value === 'object';
    });
    for (let i = 0; i <= noOfPreviousYears; i += 1) {
        const year = currentYear - i;
        if (isObject) {
            prevYears.push({ key: year, value: year });
        } else {
            prevYears.push(year.toString());
        }
    }
    ordersFilter.splice(2, 0, ...prevYears);
    return [...ordersFilter];
};

export const getFilterQuery = (fetchLastSupportedYears, filter) => {
    const date = new Date();
    const currentYear = date.getFullYear().toString();
    let dateFrom = '';
    let dateTo = time();
    if (filter === 'all') {
        dateFrom = time(`${currentYear - fetchLastSupportedYears}-01-01`);
    } else if (filter === currentYear) {
        dateFrom = time(`${filter}-01-01`);
    } else if (isString(filter) && filter.indexOf('20') > -1) {
        dateFrom = time(`${filter}-01-01`);
        dateTo = time(`${filter}-12-31`);
    } else {
        dateFrom = time().subtract(filter, 'months');
    }
    return [dateFrom, dateTo];
};

export const sortReturnLists = (returnLists, isRefundSummary) => {
    if (isRefundSummary) {
        const sortedList = orderBy(returnLists, ['returnCompletedDate'], ['desc']);
        return [...sortedList];
    }
    const InprogressItems = [];
    const otherStatusItems = [];
    forEach(returnLists, (list) => {
        list.returnStatus === 'InProgress'
            ? InprogressItems.push(list)
            : otherStatusItems.push(list);
    });
    const sortedList = orderBy(otherStatusItems, ['returnCompletedDate'], ['desc']);
    return [...InprogressItems, ...sortedList];
};
